import parcelDeliveryService from "../services/parcelDeliveryService";

export const GET_DELIVERY_INFO_DATA = "GET_DELIVERY_INFO_DATA";
export const GET_DELIVERY_INFO_DATA_SUCCESS =
    "GET_DELIVERY_INFO_DATA_SUCCESS";
export const GET_DELIVERY_INFO_DATA_ERROR =
    "GET_DELIVERY_INFO_DATA_ERROR";

export const CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA = "CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA";
export const CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_SUCCESS =
    "CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_SUCCESS";
export const CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_ERROR =
    "CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_ERROR";
export const CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_RESET =
    "CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_RESET";

// Parcel Delivery Get start
export function getDeliveryInfoDataRecord(query) {
    return async (dispatch) => {
        dispatch(getDeliveryInfoData());
        return await parcelDeliveryService
            .getDeliveryInfoData(query)

            .then((response) =>
                dispatch(getDeliveryInfoDataSuccess(response))
            )
            .catch((error) => dispatch(getDeliveryInfoDataError(error)));
    };
}

export function getDeliveryInfoData() {
    return {
        type: GET_DELIVERY_INFO_DATA,
    };
}

export function getDeliveryInfoDataSuccess(success) {
    return {
        type: GET_DELIVERY_INFO_DATA_SUCCESS,
        payload: { success },
    };
}

export function getDeliveryInfoDataError(error) {
    return {
        type: GET_DELIVERY_INFO_DATA_ERROR,
        payload: { error },
    };
}

// Parcel Delivery Get End

// Create or Update Parcel Delivery Start

export function createOrUpdateParcelDeliveryDataRecord(data) {
    return async (dispatch) => {
      dispatch(createOrUpdateParcelDeliveryData());
      return await parcelDeliveryService
        .createOrUpdateParcelDeliveryData(data)
        
        .then((response) => dispatch(createOrUpdateParcelDeliveryDataSuccess(response)))
        .catch((error) => dispatch(createOrUpdateParcelDeliveryDataError(error)));
    };
  }
  
  export function createOrUpdateParcelDeliveryData() {
    return {
      type: CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA,
    };
  }
  
  export function createOrUpdateParcelDeliveryDataSuccess(success) {
    return {
      type: CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_SUCCESS,
      payload: { success },
    };
  }
  
  export function createOrUpdateParcelDeliveryDataError(error) {
    return {
      type: CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_ERROR,
      payload: { error },
    };
  }
  
  export function createOrUpdateParcelDeliveryDataReset() {
    return {
      type: CREATE_OR_UPDATE_PARCEL_DELIVERY_DATA_RESET,
    };
  }
  // Create or Update Parcel Delivery End